import { Link } from "react-router-dom"

export default function FooterLogo() {
  return (
    <>
      <Link to="/">
        <h4 className="text-gray-700 text-4xl">Logo</h4>
      </Link>
    </>
  )
}
